import React from "react";
import "./AstroVastu.css";
import vastuBanner from "../assets/zodiac/Aquarius.jpg";
import BlogSlider from "../components/BlogSlider";
import ServiceProduts from "../components/ServiceProduts";
import ContactForm from "../components/ContactForm";

const Astrology = () => {
  return (
    <div className="services-page">
      {/* Left Side - 67% Text Content */}
      <div className="services-content">
       <h2>Welcome to Jyotish Karmaa Astrology</h2>
                <p>
                    In today’s rapidly shifting world, uncertainty has become a common thread—whether it’s about employment, 
                    economic changes, international conflicts, or personal well-being. In the midst of such unpredictability, 
                    many people turn to astrology for reassurance, direction, and a deeper understanding of life’s journey.
                     At Jyothis Karmaa, we help individuals rediscover balance and peace by aligning their life path with the movements of the cosmos.
                </p>


                <h2>Why Astrology Still Matters Today</h2>
                <p>Astrology offers a spiritual and scientific framework that many rely on to improve life standards, 
                  make health-conscious decisions, and plan for the future. From career and finance to personal growth, 
                  people often seek insight into what lies ahead—especially during uncertain times.

                </p>
                <p>Our systems of astrology analyze celestial bodies like the Sun, Moon, and planetary influences from Jupiter 
                  (Brihaspati), Mercury (Budh), Venus (Shukra), Mars (Mangal), and even outer planets like Uranus and Neptune. 
                  Special emphasis is also placed on shadow planets Rahu and Ketu, which play a key role in shaping karmic paths.
                </p>

                <h2> The Power of Vedic Astrology</h2>
                <p>At Jyothis Karmaa, we specialize in Vedic Hindu astrology, a time-honored system that studies the Kundli 
                  (birth chart or horoscope). This chart reveals the positioning of planets at the time of one’s birth and their 
                  ongoing transit through the 12 zodiac signs. We also consider significant cosmic events like solar and lunar
                   eclipses, Amavasya, Poornima, and various dashas (planetary periods) to provide deeper clarity.
                </p>
                  

                  <h2> Auspicious Timings and Ritual Guidance</h2>
                  <p>Our services extend beyond prediction. We help individuals identify Muhurats—the most favorable times for
                     initiating important activities. Whether it’s for performing Pujas, observing festivals, or planning life events,
                      our experienced astrologers and Pandits offer authentic guidance rooted in ancient traditions.
                  </p>

                  <p>Clients often consult Jyothis Karmaa for significant moments such as:</p>
                <ul className="astro-benefits">
                    <li>
                    <strong>✅ House-warming ceremonies (Griha Pravesh)</strong> 
                    </li>
                    <li>
                    <strong>✅ Baby showers (Seemantham)</strong>
                    </li>
                    <li>
                    <strong>✅ Marriage dates and compatibility checks</strong> 
                    </li>
                    <li>
                    <strong>✅ Business or financial decisions</strong> 
                    </li>
                    
                </ul>

                <h2>The 12 Zodiac Signs and You</h2>
                <p>Each of the 12 zodiac signs is governed by a ruling planet and is associated with distinct personality traits,
                   tendencies, and strengths. By understanding your sign and the planetary influences on your birth chart, 
                   you gain a more insightful perspective into your natural inclinations and potential life path.
                   
                </p>
                <p>The natal chart (or Janma Kundali) acts as a celestial blueprint, 
                  offering personalized insights into your emotional, physical, 
                  and spiritual journey. It sheds light on opportunities, challenges, and future possibilities <br/>
                  <strong>—empowering you to live with intention and purpose.</strong> </p>

                 <h2>Begin Your Journey with Jyothis Karmaa</h2> 
                 <p>Whether you're seeking personal clarity, planning an important event, or simply exploring your spiritual self, 
                  Jyothis Karmaa is here to illuminate your path through ancient wisdom and celestial science. <br/>
                  <strong>Let the stars speak. Let your Jyotish Karma guide you.</strong></p>

        {/* FAQs */}
        <div className="faq-section">
          <h3>Frequently Asked Questions</h3>
          <div className="faq"><h4>What is Astro Vastu?</h4><p>Astro Vastu combines Vastu Shastra with astrology to bring personalized solutions based on your birth chart.</p></div>
          <div className="faq"><h4>Can this service be done remotely?</h4><p>Yes, we offer remote consultations through video calls and shared floor plans.</p></div>
          <div className="faq"><h4>How do I choose a gemstone?</h4><p>We analyze your birth chart and planetary positions to recommend suitable gemstones.</p></div>
          <div className="faq"><h4>What is the benefit of Rudraksha?</h4><p>Rudraksha beads help in spiritual growth and balancing chakras and energy fields.</p></div>
        </div>

        {/* Blog Slider */}
            <div className="recent-blogs">
                    
                     <BlogSlider />
            </div>

      </div>

      {/* Right Side - 33% Banner Image, Contact, Social, Buy */}
      <div className="sidebar">
        <div className="banner-image">
          <img src="/assets/profile/Jyotish_karam_profile.jpeg" alt="Astro Vastu Services Banner" />
        </div>

        <div className="social-follow">
          <h4>Follow Us</h4>
          <div className="social-icons">
            <a href="#"><i className="fab fa-facebook-f" /></a>
            <a href="#"><i className="fab fa-instagram" /></a>
            <a href="#"><i className="fab fa-twitter" /></a>
            <a href="#"><i className="fab fa-linkedin-in" /></a>
            <a href="#"><i className="fab fa-pinterest-p" /></a>
            <a href="#"><i className="fab fa-youtube" /></a>
          </div>
        </div>

        <ContactForm />

       
          <ServiceProduts />
        
      </div>
    </div>
  );
};

export default Astrology;
